import { Dialog } from "@finanedi.es/storybook"
import { useQuery } from "@tanstack/react-query"
import { getAsientoById } from "api/AsientoContable.service"
import { TIPO_IMPORTACION_ASIENTO } from "api/Types/TipoImportacionAsiento"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"
import FormAsientoFormik from "./FormAsientoContable"
import { AsientoContableFormikProps } from "./constant"

const ModalAsientoContable = ({
  show,
  setShow,
  idToEdit,
  updateTable,
  preData,
}: {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>> | ((show: boolean) => void)
  idToEdit: string | boolean | undefined
  updateTable: (responseData?: string) => void
  preData?: Partial<AsientoContableFormikProps>
}) => {
  const { t } = useTranslation()
  const {
    data: asientoDto,
    isLoading: asientoDtoIsLoading,
    refetch: asientoDtoRefetch,
  } = useQuery({
    queryKey: ["asientoDto", idToEdit],
    queryFn: () => getAsientoById(idToEdit as string),
    enabled: Boolean(idToEdit),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: false,
  })

  const onHideModal = (refetch?: boolean) => {
    setShow(!show)
    if (refetch && idToEdit) asientoDtoRefetch()
  }

  return (
    <Dialog
      visible={show && !asientoDtoIsLoading}
      data-is-importacion={
        asientoDto?.tipoImportacionAsiento ===
        TIPO_IMPORTACION_ASIENTO.LIBRO_IVA_SAGE
      }
      className='tw-w-320 !tw-z-20 tw-rounded-lg tw-bg-white tw-max-h-screen !tw-transition-none !tw-transform-none tw-h-5/6 data-[is-importacion=true]:tw-h-3/5'
      contentClassName='tw-max-h-[calc(100%-72px)] !tw-overflow-hidden'
      baseZIndex={20}
      closable
      keepInViewport={false}
      maximizable
      resizable
      pt={{
        root: {
          className: `!tw-z-20 !tw-max-h-screen !tw-overflow-hidden ${
            asientoDto?.tipoImportacionAsiento ===
            TIPO_IMPORTACION_ASIENTO.LIBRO_IVA_SAGE
              ? ""
              : "!tw-min-h-171.25"
          }`,
        },
      }}
      header={
        idToEdit
          ? `${t("diario.modal.editTitle")} ${t("diario.modal.entryTitle")}: ${
              asientoDto?.numero
            }`
          : `${t("diario.modal.createTitle")} ${t("diario.modal.entryTitle")}`
      }
      headerClassName='[&>:first-child]:!tw-text-xl'
      onHide={onHideModal}
    >
      <FormAsientoFormik
        t={t}
        onHideModal={onHideModal}
        data={idToEdit ? asientoDto : undefined}
        updateTable={updateTable}
        asientoDto={asientoDto}
        preData={preData}
      />
    </Dialog>
  )
}

export default ModalAsientoContable
